import React, { Fragment, useState } from "react";
import styled, { css } from "styled-components";
import {
  Button,
  FormGroup,
  ContentBlock,
  Tooltip,
} from "xsolla-uikit";

import { vc } from "../../data/vc";
import PAh2 from "../PAh2";
import CardNew, { CardItem } from "../PAcardNew";
import { Link } from "react-router-dom";
import PAvcPacks from "./PAvcPacks";

import { CssVCimage } from '../uikit2'







const makeVc = (oneV) => ({


        product: "currency",
        sku: oneV['sku'],
        name: oneV['title'],
        price: `${oneV['prices_array'][0]['name']} ${oneV['prices_array'][0]['value']}`,
        prices_array: oneV['prices_array'],
        price_currency: oneV['prices_array'][0]['name'],
        id: oneV['id'],
        img: () => {
          return (
            <div className="">
              {/* <Tooltip label="Click to test payment in a sandbox mode"> */}
                <CssVCimage image_url={oneV['image_url']}/>
              {/* </Tooltip> */}
              {/* <CssButH>
            My Game: Ultimate Edition
          </CssButH> */}
            </div>
          );
        },
        status: "active",

        button: () => <Link to="/microtransactions/new_currency">
          <Button appearance="outline">Edit Currency</Button>
        </Link>


})









const getCurrencyData = (sku, what = 'image_url') => {
  let a = vc.filter((oneV)=>oneV['sku'] === sku)
  return a[0][what]
}




export default function PAvcs({
  history,
  view = 'row',
 }) {

  const [cardType, setCardType] = useState(view);



  const [newKey, setNewKey] = useState(false);


  const [tab, setTab] = useState();

  return (
    <ContentBlock
        appearance="flatten"
        >





        <CSScards
          appearance='flatten'
          cardType={cardType}
        >


            {vc.map((oneV, ind) => {
              let dataForCard = makeVc(oneV)
              return (
                <FormGroup indentation="xs" key={`login_${ind}`}>
                <ContentBlock
                // appearance="flatten"
                >

              <FormGroup indentation="md">
                <CssCardItem
                  appearance="flatten"
                  cardType={cardType}
                >
                  <CardItem
                    appearance="flatten"
                    product="currency"
                    cardType={cardType}
                    size="sm"
                    {...dataForCard}
                    key={`vc_${ind}`}
                    />
                </CssCardItem>
              </FormGroup>

              <FormGroup indentation="md">


                    <PAvcPacks
                      packs={oneV['packs']}
                      currency={oneV['id']}
                      image_url = {oneV['image_url']}
                    />


              </FormGroup>

                </ContentBlock>
                </FormGroup>
              );
            })}
        </CSScards>


      <FormGroup indentation="lg">
        <div style={{display: 'flex'}}>
          <Button
            style={{opacity: cardType === 'row' ? 0.4 : 1}}
            onClick={()=>{setCardType(false)}}
            appearance="flatten">Cards</Button>&nbsp;
          <Button
            style={{opacity: cardType !== 'row' ? 0.4 : 1}}
            onClick={()=>{setCardType('row')}}
            appearance="flatten">Rows</Button>
        </div>
      </FormGroup>

    </ContentBlock>
  );
}

const CSScards = styled.div`
  ${({ cardType }) =>
    cardType === 'row'
      ? css`
          width: 100%;
          display: grid;
          grid-template-columns: 1fr;
          grid-column-gap: 24px;
          /* grid-auto-rows: minmax(min-content, max-content); */
          grid-row-gap: 24px;
          place-content: stretch;
        `
      : css`
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px,1fr));
          grid-column-gap: 24px;
          grid-row-gap: 24px;
          place-content: stretch;
        `};
`;

const CssCardItem = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  flex-grow: 1;
  ${({ cardType }) =>
    cardType === 'row'
      ? css`
          height: 220px
        `
      : css`

        `};
`;



